import { emptySplitApi } from "./index";
import { getTeamKeyStorage } from "src/utils/token";

// Define a service using a base URL and expected endpoints
export const usersApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    // 获取团队操作日志
    getTeamUserLog: builder.query({
      query: (params) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/team-user-log`,
        method: "GET",
        params,
      }),
      providesTags: ["users"],
    }),
    // 获取用户信息
    getUserInfo: builder.query({
      query: () => `/api-v2/teams/${getTeamKeyStorage()}/current`,
      providesTags: ["users"],
    }),
    // 获取用户列表
    getUserList: builder.query({
      query: ({ keyword, role } = {}) => {
        return {
          url: `/api-v2/teams/${getTeamKeyStorage()}/team-user/list`,
          method: "GET",
          params: {
            keyword,
            role,
            size: 150,
          },
        };
      },
      transformResponse: (response) => {
        return response?.code === 200 ? response.data : [];
      },
      providesTags: ["users", "team-field"],
    }),
    // 查询团队所有HR和HR管理员成员
    getAdminList: builder.query({
      query: (params) => {
        return {
          url: `/api-v2/teams/${getTeamKeyStorage()}/team-hr-or-admin-users`,
          method: "GET",
          params,
        };
      },
      providesTags: ["users"],
    }),
    // 批量自动注册团队成员
    inviteRegistersDingTalk: builder.mutation({
      query: (data) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/invite-registers-ding-talk`,
        method: "POST",
        body: data,
      }),
    }),
    // 取消HR-Admin权限
    postCancelAdmin: builder.mutation({
      query: ({ teamUserId }) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/undo-team-hr-admin-user-role/${teamUserId}`,
        method: "POST",
      }),
      invalidatesTags: ["users"],
    }),
    // 取消HR权限
    postCancelHR: builder.mutation({
      query: ({ teamUserId }) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/undo-team-hr-user-role/${teamUserId}`,
        method: "POST",
      }),
      invalidatesTags: ["users"],
    }),
    // 设置人员身份
    postUserRole: builder.mutation({
      query: ({ teamUserId, role }) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/team-user-role/${teamUserId}/${role}`,
        method: "POST",
      }),
      invalidatesTags: ["users"],
    }),
    // 设置人员身份(批量)
    postUserRolePatch: builder.mutation({
      query: ({ teamUserIds, role }) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/team-user-roles/${role}`,
        method: "POST",
        body: {
          teamUserIds,
        },
      }),
      invalidatesTags: ["users"],
    }),
    // 转让HR管理员身份
    postTransferRole: builder.mutation({
      query: (body) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/team-user/transfer-current-role`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["users"],
    }),
    // 转让HR管理员身份
    postTransferHR: builder.mutation({
      query: (body) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/team-user/transfer-current-hr-role`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["users"],
    }),
    // 根据类型获取团队下字段结构列表
    getTeamFieldStructure: builder.query({
      query: ({ type }) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/team-field-structure/${type}`,
        method: "GET",
      }),
      providesTags: ["team-field"],
    }),
    // 根据类型获取团队下启用字段结构列表
    getListTeamFieldStructure: builder.query({
      query: ({ type }) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/team-field-structure/${type}/enable-list`,
        method: "GET",
      }),
      providesTags: ["team-field"],
    }),
    //获取团队指定成员字段结构对应值列表
    getUserTeamFieldStructure: builder.query({
      query: ({ type, teamUserId }) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/team-field-structure/${type}/users/${teamUserId}/values`,
        method: "GET",
      }),
      providesTags: ["team-field"],
    }),
    // 根据类型创建团队下字段结构
    postTeamFieldStructure: builder.mutation({
      query: ({ type, body }) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/team-field-structure/${type}`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["team-field"],
    }),
    // 保存团队指定成员下的字段结构对应值-超级管理员权限
    postUserTeamFieldStructure: builder.mutation({
      query: ({ type, body, teamUserId }) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/team-field-structure/${type}/users/${teamUserId}/values`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["team-field"],
    }),
    // 编辑团队下字段结构
    putTeamFieldStructure: builder.mutation({
      query: ({ type, body, field }) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/team-field-structure/${type}/field/${field}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["team-field"],
    }),
    // 删除团队下字段结构
    deleteTeamFieldStructure: builder.mutation({
      query: ({ type, field }) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/team-field-structure/${type}/field/${field}`,
        method: "DELETE",
      }),
      invalidatesTags: ["team-field"],
    }),
    // 团队下字段结构字段修改状态
    postStatusTeamFieldStructure: builder.mutation({
      query: ({ type, status, field }) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/team-field-structure/${type}/fileKey/${field}/status/${status}`,
        method: "POST",
      }),
      invalidatesTags: ["team-field"],
    }),
    // 团队下字段结构字段排序
    postSortTeamFieldStructure: builder.mutation({
      query: ({ type, body }) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/team-field-structure/${type}/sort`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["team-field"],
    }),
    // 根据类型获取团队下字段结构列表
    getValuesTeamFieldStructure: builder.query({
      query: ({ type, teamUserId }) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/team-field-structure/${type}/users/${teamUserId}/values`,
        method: "GET",
      }),
      providesTags: ["team-field"],
    }),
    // 保存团队下字段结构对应值
    postValuesFTeamFieldStructure: builder.mutation({
      query: ({ type, body }) => ({
        url: `/api-v2/teams/${getTeamKeyStorage()}/team-field-structure/${type}/values`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["team-field"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetUserListQuery,
  useGetAdminListQuery,
  useGetTeamUserLogQuery,
  usePostTransferRoleMutation,
  usePostTransferHRMutation,
  usePostUserRolePatchMutation,
  useGetTeamFieldStructureQuery,
  usePostTeamFieldStructureMutation,
  usePutTeamFieldStructureMutation,
  usePostStatusTeamFieldStructureMutation,
  usePostSortTeamFieldStructureMutation,
  useDeleteTeamFieldStructureMutation,
  useGetListTeamFieldStructureQuery,
  useGetUserTeamFieldStructureQuery,
  usePostUserTeamFieldStructureMutation,
} = usersApi;
